export default __webpack_public_path__ + "static/media/linkedin.74d0f64c.png";